import { render, staticRenderFns } from "./starRating.vue?vue&type=template&id=c57dd4e0&"
import script from "./starRating.vue?vue&type=script&lang=js&"
export * from "./starRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports